import './main.css'
import '../App.css'
import { useEffect, useRef, useState } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo, faCircleXmark, faDollarSign } from "@fortawesome/free-solid-svg-icons";
import MessageModal from '../Pages/messageModal';
import { useDispatch, useSelector } from 'react-redux';
import { changeAlramModal, checkDuplicateLogins } from '../store';
import axios from 'axios';
import { changeNum, changeUnits } from './common/function';
import { useTranslation } from "react-i18next";
import { ethers } from 'ethers';

function AirDrop() {
    const { t } = useTranslation();
    let JWT = useSelector((state) => { return state.JWT.value })
    let dispatch = useDispatch()
    const [message, setMessage] = useState("");
    const [tab, setTab] = useState(0)
    const [infoModal, setInfoModal] = useState(false)
    const [rateData, setRateData] = useState([])

    const [input, setInput] = useState("")

    const wrapperRef = useRef(null); // ref 생성

    useEffect(() => {
        AirdropRate()
        AirdropHistory()
    }, [])

    const AirdropRate = async () => {
        await axios.get(process.env.REACT_APP_API + '/api/airdrop', {
            headers: { Authorization: `Bearer ${JWT}` }
        }).then((response) => {
            let tmp = response.data
            if (tmp?.code == 1000) {
                setRateData(tmp?.data ?? [])
            }
        }).catch((error) => {
            if (error?.status === 999) {
                dispatch(checkDuplicateLogins(true))
            }
            else {
                console.log(error)
            }
        })
    };

    const AirdropHistory = async () => {
        await axios.get(process.env.REACT_APP_API + '/api/airdrop/history', {
            headers: { Authorization: `Bearer ${JWT}` }
        }).then((response) => {
            let tmp = response.data
            if (tmp?.code == 1000) {
                if (tmp?.data?.history) {
                    setInput(tmp?.data?.history[0]?.wallet_address ?? "")
                }
            }
        }).catch((error) => {
            if (error?.status === 999) {
                dispatch(checkDuplicateLogins(true))
            }
            else {
                console.log(error)
            }
        })
    };

    const isAllZeros = (address) => {
        // 0x를 제외한 나머지 부분이 모두 0인지 확인
        const value = address.slice(2);
        return /^0+$/.test(value); // 정규 표현식으로 모든 문자가 0인지 확인
    };

    const CheckAirdropAddress = async () => {
        if (ethers.isAddress(input)) {
            let data = JSON.stringify({
                jsonrpc: "2.0",
                method: "eth_call",
                params: [
                    {
                        "to": "0xEf43bF8C6430A615BBa48987aE2522E3A3bE0A18",
                        "data": `0x70a08231000000000000000000000000${input.slice(2)}`
                    },
                    "latest"
                ],
                id: 1
            });

            await axios.post('https://bsc.blockrazor.xyz/', data, {
                headers: {
                    'Content-Type': 'application/json',
                    'Cookie': '__cflb=0H28vjNUKzitFxPEYnfbdsSkrqfPzud2aTsk9v4eaDq'
                }
            })
                .then((response) => {
                    let tmp = response.data;
                    if (tmp?.result) {
                        if (isAllZeros(input)) {
                            setMessage({ "code": 1, "msg": t('message_8') })
                            dispatch(changeAlramModal())
                        } else {
                            AirdropApply()
                        }
                    }
                    else {
                        setMessage({ "code": 1, "msg": t('message_8') })
                        dispatch(changeAlramModal())
                    }
                })
                .catch((error) => {
                    if (error?.status === 999) {
                        dispatch(checkDuplicateLogins(true))
                    }
                    else {
                        console.log(error)
                    };
                });
        } else {
            setMessage({ "code": 1, "msg": t('message_8') })
            dispatch(changeAlramModal())
        }
    };

    const AirdropApply = async () => {
        await axios.post(process.env.REACT_APP_API + '/api/airdrop', {
            address: input
        }, {
            headers: { Authorization: `Bearer ${JWT}` }
        }).then((response) => {
            let tmp = response.data
            if (tmp?.code == 1000) {
                setMessage({ "code": 0, "msg": t('message_6') })
                dispatch(changeAlramModal())
                localStorage.setItem('airdropApply', input)
            }
        }).catch((error) => {
            if (error?.status === 999) {
                dispatch(checkDuplicateLogins(true))
            }
            else {
                console.log(error)
            }
        })
    };

    return (
        <div className='main notheader' style={{ paddingTop: "0" }}>
            <MessageModal message={message} />
            {infoModal && (<AirdropModal setInfoModal={setInfoModal} />)}
            <div className='' style={{ position: "relative", width: "100%" }}>
                <div
                    ref={wrapperRef}
                    className='page-img-wrapper'
                    style={{ marginBottom: "20px", overflow: "hidden", position: "relative" }}
                >
                    <img
                        src='/newImg/splash_03(unused)(3000x5372)_airdrop.png'
                        className='page-img'
                        style={{ pointerEvents: "none", width: "100%", height: "100%", objectFit: "container" }} // 이미지에만 클릭 이벤트 비활성화
                    />
                </div>
                <div className='airdrop-body' style={{
                    zIndex: "1000", position: "absolute", top: "0",
                    paddingTop: "300px"
                }}>
                    {/* <div className='airdrop-tab'>
                        <div className={`airdrop-tab-item ${tab === 0 ? "active" : ""}`} onClick={() => setTab(0)}>Tokens</div>
                        <div className={`airdrop-tab-item ${tab === 1 ? "active" : ""}`} onClick={() => setTab(1)}>Withdrawal</div>
                    </div> */}
                    <div className='airdrop-text' style={{ position: 'relative', marginBottom: "20px" }}>
                        <div style={{ fontSize: "26px", fontWeight: "bold", marginBottom: "10px" }}>Let's go!</div>
                        <div className='airdrop-text-1' style={{ marginBottom: "10px", width: "170px" }} onClick={() => window.open('https://www.gate.io/trade/SAY_USDT')}>
                            <img src='/newImg/gate.png' style={{ height: "42px" }} />
                        </div>
                        <div style={{ color: "#b9b9b9", fontSize: "14px" }}>token is on the market</div>
                    </div>

                    <div className='airdrop-input'>
                        <div className='airdrop-box-item' style={{ marginBottom: "20px" }}>
                            <div>
                                <span style={{ fontSize: '16px', paddingRight: "5px" }}>{t('airdrop_0')}</span>
                                <span style={{ fontSize: "14px", color: "gray", textAlign: "right", fontWeight: "500" }}>({rateData?.rate ?? ""})</span>
                            </div>
                            <span className="dots"></span>
                            <div className='number fontNumber'>
                                <div style={{ display: 'flex', alignItems: "center" }}>
                                    <span>{changeUnits(rateData?.token ?? 0)}</span>
                                </div>
                            </div>
                        </div>
                        <div className='airdrop-input-box-1'>{t('airdrop_1')}</div>
                        <div className='airdrop-input-box-2'>
                            <div className="airdrop-input-box-2-1" style={{ textAlign: "left" }}>
                                <div className='table-overflow-hidden'>
                                    {rateData?.address ?? ""}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='airdrop-box'>
                        <div className='airdrop-box-item'>
                            <span>{t('airdrop_3')}</span>
                            <span className="dots"></span>
                            <div className='number fontNumber'>
                                <div style={{ display: 'flex', alignItems: "center" }}>
                                    <span>{changeUnits(0)}</span>
                                </div>
                            </div>
                        </div>
                        <div className='airdrop-box-item'>
                            <span>{t('airdrop_4')}</span>
                            <span className="dots"></span>
                            <div className='number fontNumber'>
                                <div style={{ display: 'flex', alignItems: "center" }}>
                                    <span>{changeUnits(0)}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className='airdrop-box-list'>
                        <img src='/img/gold.png' style={{ width: "45px" }} />
                        <div className='airdrop-list-text' style={{ fontSize: "14px" }}>
                            <div style={{ marginBottom: '5px' }}>Passive income</div>
                            <div className='airdrop-list-text2'>
                                <i className="fa-brands fa-bitcoin" style={{ fontSize: '17px', color: "#ffbb3f", marginRight: "5px" }}></i>
                                123
                            </div>
                        </div>
                        <FontAwesomeIcon icon={faCircleInfo} className='airdrop-icon' onClick={() => setInfoModal(true)} />
                    </div> */}
                </div>
            </div>
        </div>

    )
}

function AirdropModal({ setInfoModal }) {
    return (
        <div className='modal'>
            <div className='modal-background' onClick={() => setInfoModal(false)}></div>
            <div className='airdrop-modal'>
                <FontAwesomeIcon icon={faCircleXmark} className='modal-x' onClick={() => setInfoModal(false)} />
                <i className="fa-brands fa-bitcoin" style={{ fontSize: '55px', color: "#ffbb3f", marginBottom: "15px" }}></i>
                <div style={{ fontSize: '27px', fontWeight: "500", marginBottom: "15px" }}>Passive income</div>
                <div style={{ marginBottom: "15px" }}>
                    <i className="fa-brands fa-bitcoin" style={{ fontSize: '17px', color: "#ffbb3f", marginRight: "5px" }}></i>
                    123
                </div>
                <div style={{ fontSize: "13px", marginBottom: '20px' }}>The golden rule of a successful business is that it should work for you. Passive income is an important concept of the game. Invest your in-game currency and make sure your exchange mines more assets for you.
                </div>
                <div className='modal-airdrop-btn' onClick={() => setInfoModal(false)}>Close</div>
            </div>
        </div>
    )
}

export default AirDrop;